import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="w-full pt-28 pb-20 md:pt-32 md:pb-28 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">PRIVACY POLICY</p>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                プライバシーポリシー
              </h1>
            </div>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed">
              <p className="text-sm md:text-base mb-8">
                株式会社Ｄｒｅａｍ（以下「当社」といいます）は、お客様の個人情報の重要性を認識し、
                その適切な保護と管理に努めてまいります。本プライバシーポリシーでは、
                当社が収集する個人情報の種類、利用目的、管理体制等について定めております。
              </p>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第1条（個人情報の収集）</h2>
              <p className="text-sm md:text-base mb-4">
                当社は、以下の方法によりお客様の個人情報を収集することがあります。
              </p>
              <ul className="list-disc pl-5 text-sm md:text-base mb-4 flex flex-col gap-2">
                <li>お問い合わせフォームからのご入力</li>
                <li>お電話、メール、FAX等によるお問い合わせ</li>
                <li>営業活動・商談等を通じた名刺等のご提供</li>
                <li>業務委託契約等の締結に伴う情報提供</li>
              </ul>
              <p className="text-sm md:text-base mb-4">
                収集する個人情報には、お名前、会社名、電話番号、メールアドレス、ご住所等が含まれます。
              </p>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第2条（個人情報の利用目的）</h2>
              <p className="text-sm md:text-base mb-4">
                当社は、収集した個人情報を以下の目的で利用いたします。
              </p>
              <ul className="list-disc pl-5 text-sm md:text-base mb-4 flex flex-col gap-2">
                <li>お問い合わせに対するご返信・ご連絡</li>
                <li>営業支援・コンサルティングサービスの提供</li>
                <li>サービスに関するご案内・資料の送付</li>
                <li>契約の締結・履行に関する業務</li>
                <li>サービス改善のための分析・マーケティング</li>
                <li>法令に基づく対応</li>
              </ul>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第3条（個人情報の第三者提供）</h2>
              <p className="text-sm md:text-base mb-4">
                当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはございません。
              </p>
              <ul className="list-disc pl-5 text-sm md:text-base mb-4 flex flex-col gap-2">
                <li>お客様ご本人の同意がある場合</li>
                <li>法令に基づき開示が求められた場合</li>
                <li>人の生命、身体または財産の保護のために必要な場合で、お客様の同意を得ることが困難である場合</li>
                <li>業務委託先に対して、委託業務の遂行に必要な範囲で提供する場合（この場合、委託先に対しても適切な管理を義務付けます）</li>
              </ul>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第4条（個人情報の安全管理）</h2>
              <p className="text-sm md:text-base mb-4">
                当社は、お客様の個人情報を正確かつ最新の状態に保つとともに、
                不正アクセス、紛失、破壊、改ざん、漏洩等を防止するため、
                適切なセキュリティ対策を実施しております。
              </p>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第5条（個人情報の開示・訂正・削除）</h2>
              <p className="text-sm md:text-base mb-4">
                お客様がご自身の個人情報の開示、訂正、削除等を希望される場合は、
                下記お問い合わせ窓口までご連絡ください。ご本人確認の上、合理的な範囲で速やかに対応いたします。
              </p>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第6条（Cookieについて）</h2>
              <p className="text-sm md:text-base mb-4">
                当社のウェブサイトでは、サービスの利便性向上やアクセス解析のためにCookieを使用する場合があります。
                お客様はブラウザの設定によりCookieの受け入れを拒否することができますが、
                その場合、一部のサービスが正常に機能しない可能性があります。
              </p>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第7条（お問い合わせ窓口）</h2>
              <p className="text-sm md:text-base mb-4">
                本プライバシーポリシーに関するお問い合わせは、下記までご連絡ください。
              </p>
              <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 text-sm md:text-base mb-4">
                <p className="font-bold mb-2">株式会社Ｄｒｅａｍ</p>
                <p>住所：神奈川県横浜市西区北幸２丁目１０番４８号むつみビル３階</p>
                <p>代表取締役：笹川俊</p>
                <p>個人情報保護管理者：笹川俊</p>
                <p>メール：banking@dream-dreaminc.com</p>
              </div>

              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4">第8条（プライバシーポリシーの改定）</h2>
              <p className="text-sm md:text-base mb-4">
                当社は、法令の改正や事業内容の変更等に伴い、本プライバシーポリシーを改定することがあります。
                改定内容は本ページに掲載し、掲載された時点で効力を生じるものとします。
              </p>

              <p className="text-sm md:text-base mt-10 text-foreground-500">
                株式会社Ｄｒｅａｍ
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
